document.addEventListener('DOMContentLoaded', () => {
    const spotlightSections = document.querySelectorAll('.moodboard-spotlight-section');
  
    spotlightSections.forEach(section => {
      // --- HERO SLIDER ENGINE ---
      // Handles multiple hero images within a single spotlight section.
      
      const heroSlider = section.querySelector('.moodboard-hero-slider');
      const heroTrack = section.querySelector('.moodboard-hero-slider__track');
      const slides = section.querySelectorAll('.moodboard-hero-slide');
      const dots = section.querySelectorAll('.hero-dot');
      const arrowPrev = section.querySelector('.hero-nav--prev');
      const arrowNext = section.querySelector('.hero-nav--next');
      
      let heroIndex = 0; 
  
      // Initialize Slider
      if (heroSlider && heroTrack) {
          heroSlider.style.overflowX = 'hidden'; 
          heroSlider.style.scrollSnapType = 'none'; 
          heroTrack.style.display = 'flex';
          heroTrack.style.width = '100%'; 
          heroTrack.style.height = '100%';
          heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
          heroTrack.style.willChange = 'transform';
          
          slides.forEach(slide => {
              slide.style.flex = '0 0 100%';      
              slide.style.width = '100%';         
              slide.style.maxWidth = '100%';      
              slide.style.boxSizing = 'border-box';
          });
      }
  
      function updateHeroSlide(newIndex) {
          if (!slides.length) return;
          if (newIndex < 0) newIndex = slides.length - 1; 
          if (newIndex >= slides.length) newIndex = 0;
  
          heroIndex = newIndex;
  
          if (heroTrack) {
              heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
              heroTrack.style.transform = `translateX(-${heroIndex * 100}%)`;
          }
  
          dots.forEach(d => d.classList.remove('is-active'));
          if (dots[heroIndex]) dots[heroIndex].classList.add('is-active');
      }
  
      // --- TOUCH Logic (Mobile/Tablet) ---
      let hStartX = 0;
      let hStartY = 0;
      let hIsDragging = false;
      let isHorizontalSwipe = false;
      let isDirectionDetermined = false;
  
      if (heroSlider) {
          heroSlider.addEventListener('touchstart', (e) => {
              hStartX = e.touches[0].clientX;
              hStartY = e.touches[0].clientY;
              hIsDragging = true;
              isDirectionDetermined = false;
              isHorizontalSwipe = false;
              if (heroTrack) heroTrack.style.transition = 'none';
          }, { passive: true });
  
          heroSlider.addEventListener('touchmove', (e) => {
              if (!hIsDragging) return;
  
              const currentX = e.touches[0].clientX;
              const currentY = e.touches[0].clientY;
              const diffX = currentX - hStartX;
              const diffY = currentY - hStartY;
  
              if (!isDirectionDetermined) {
                  if (Math.abs(diffX) < 5 && Math.abs(diffY) < 5) return;
                  isDirectionDetermined = true;
                  if (Math.abs(diffX) > Math.abs(diffY)) {
                      isHorizontalSwipe = true;
                  } else {
                      isHorizontalSwipe = false;
                      // Restore transition if it's a vertical scroll so it doesn't get stuck
                      if (heroTrack) heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
                  }
              }
  
              if (isHorizontalSwipe) {
                  e.stopPropagation(); 
                  if (heroTrack) {
                      const slideWidth = heroSlider.offsetWidth;
                      const currentOffset = -heroIndex * slideWidth;
                      const newOffset = currentOffset + diffX;
                      heroTrack.style.transform = `translateX(${newOffset}px)`;
                  }
              }
          }, { passive: false }); 
  
          heroSlider.addEventListener('touchend', (e) => {
              if (!hIsDragging) return;
              hIsDragging = false;
  
              if (!isHorizontalSwipe) {
                   if (heroTrack) {
                       heroTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
                       heroTrack.style.transform = `translateX(-${heroIndex * 100}%)`;
                   }
                  return;
              }
  
              e.stopPropagation(); 
  
              const hEndX = e.changedTouches[0].clientX;
              const diffX = hEndX - hStartX;
              const threshold = 50; 
  
              if (diffX > threshold) {
                  updateHeroSlide(heroIndex - 1);
              } else if (diffX < -threshold) {
                  updateHeroSlide(heroIndex + 1);
              } else {
                  updateHeroSlide(heroIndex);
              }
          }, { passive: true });
  
          // --- MOUSE Logic (Desktop) ---
          heroSlider.addEventListener('mousedown', (e) => {
              hStartX = e.clientX;
              hIsDragging = true;
              isDirectionDetermined = true; 
              isHorizontalSwipe = true;
              
              if (heroTrack) heroTrack.style.transition = 'none';
              e.preventDefault(); 
          });
  
          heroSlider.addEventListener('mousemove', (e) => {
              if (!hIsDragging || !isHorizontalSwipe) return;
              e.preventDefault();
  
              const currentX = e.clientX;
              const diffX = currentX - hStartX;
  
              if (heroTrack) {
                  const slideWidth = heroSlider.offsetWidth;
                  const currentOffset = -heroIndex * slideWidth;
                  const newOffset = currentOffset + diffX;
                  heroTrack.style.transform = `translateX(${newOffset}px)`;
              }
          });
  
          const endMouseDrag = (e) => {
              if (!hIsDragging) return;
              hIsDragging = false;
  
              const diffX = e.clientX - hStartX;
              const threshold = 50;
  
              if (diffX > threshold) {
                  updateHeroSlide(heroIndex - 1);
              } else if (diffX < -threshold) {
                  updateHeroSlide(heroIndex + 1);
              } else {
                  updateHeroSlide(heroIndex);
              }
          };
  
          heroSlider.addEventListener('mouseup', endMouseDrag);
          heroSlider.addEventListener('mouseleave', endMouseDrag);
      }
  
      // Arrows
      if (arrowPrev) {
        arrowPrev.addEventListener('click', (e) => {
          e.stopPropagation();
          updateHeroSlide(heroIndex - 1);
        });
      }
      if (arrowNext) {
        arrowNext.addEventListener('click', (e) => {
          e.stopPropagation();
          updateHeroSlide(heroIndex + 1);
        });
      }
  
      // Dots
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          updateHeroSlide(dotIndex);
        });
      });
  
    });
  });